import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { PlayerService } from '../services/player/player.service';
import { Player } from '../models/player';

@Injectable({ providedIn: 'root' })
export class PlayerResolver implements Resolve<Player> {
  constructor(private playerService: PlayerService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Player> {
    const id = route.params['playerId'];
    return this.playerService.getById(id);
  }
}
